import { memo } from 'react'
import { AnalyticsOverview } from './AnalyticsOverview'

export const RightSidebar = memo(function RightSidebar() {
  return (
    <aside className="print-hide right-sidebar hidden h-screen w-[320px] min-w-[320px] shrink-0 flex-col border-l border-border bg-muted/20 xl:flex">
      {/* Scrollable Analytics Section */}
      <div className="flex-1 overflow-y-auto pt-4">
        <AnalyticsOverview />
      </div>
    </aside>
  )
})
